import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LayoutModule } from '@core/components/layout/layout.module';
import { AvatarModule } from '@core/components/avatar/avatar.module';
import { HelperBoxModule } from '@core/components/helpers/box/box.module';

// components
import { AIMainComponent } from './main/main.component';
import { AIQuestionComponent } from './question/question.component';
import { AIAnswerComponent } from './answer/answer.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        LayoutModule,
        AvatarModule,
        HelperBoxModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        AIMainComponent,
        AIQuestionComponent,
        AIAnswerComponent
    ],
    exports: [
        AIMainComponent
    ],

})
export class AIAppModule { }
